import { render } from "./AddNewPhysician.vue?vue&type=template&id=655b27c2"
import script from "./AddNewPhysician.vue?vue&type=script&lang=js"
export * from "./AddNewPhysician.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/physicians/AddNewPhysician.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "655b27c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('655b27c2', __exports__)) {
    console.log('reload')
    api.reload('655b27c2', __exports__)
  }
  
  module.hot.accept("./AddNewPhysician.vue?vue&type=template&id=655b27c2", () => {
    console.log('re-render')
    api.rerender('655b27c2', render)
  })

}


export default __exports__